/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigPowerScheduleSelect_CustomerFragment = { __typename: 'Customer', id: string, powerSchedules: Array<{ __typename: 'PowerSchedule', id: string, title: string }> };

export type ConfigPowerScheduleSelect_ConfigFragment = { __typename: 'ConfigurationModel', id: string, powerSchedule?: { __typename: 'ConfigPowerSchedule', schedule?: { __typename: 'PowerSchedule', id: string, title: string, timeBlocks: Array<{ __typename: 'TimeBlock', start: string, end: string, day: Types.Day }> } | null } | null };

export type ConfigUpdatePowerScheduleMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdatePowerScheduleInput;
}>;


export type ConfigUpdatePowerScheduleMutation = { __typename: 'Mutation', configurationUpdatePowerSchedule: { __typename: 'ConfigurationModel', id: string } };

export const ConfigPowerScheduleSelect_CustomerFragmentDoc = gql`
    fragment ConfigPowerScheduleSelect_customer on Customer {
  id
  powerSchedules {
    id
    title
  }
}
    `;
export const ConfigPowerScheduleSelect_ConfigFragmentDoc = gql`
    fragment ConfigPowerScheduleSelect_config on ConfigurationModel {
  id
  powerSchedule {
    schedule {
      id
      title
      timeBlocks {
        start
        end
        day
      }
    }
  }
}
    `;
export const ConfigUpdatePowerScheduleDocument = gql`
    mutation ConfigUpdatePowerSchedule($input: ConfigurationUpdatePowerScheduleInput!) {
  configurationUpdatePowerSchedule(input: $input) {
    id
  }
}
    `;
export type ConfigUpdatePowerScheduleMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdatePowerScheduleMutation, ConfigUpdatePowerScheduleMutationVariables>;

/**
 * __useConfigUpdatePowerScheduleMutation__
 *
 * To run a mutation, you first call `useConfigUpdatePowerScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdatePowerScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdatePowerScheduleMutation, { data, loading, error }] = useConfigUpdatePowerScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdatePowerScheduleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdatePowerScheduleMutation, ConfigUpdatePowerScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdatePowerScheduleMutation, ConfigUpdatePowerScheduleMutationVariables>(ConfigUpdatePowerScheduleDocument, options);
      }
export type ConfigUpdatePowerScheduleMutationHookResult = ReturnType<typeof useConfigUpdatePowerScheduleMutation>;
export type ConfigUpdatePowerScheduleMutationResult = ApolloReactCommon.MutationResult<ConfigUpdatePowerScheduleMutation>;
export type ConfigUpdatePowerScheduleMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdatePowerScheduleMutation, ConfigUpdatePowerScheduleMutationVariables>;